import React, { useEffect, useState } from "react"
import { Row } from "reactstrap"

// ─── Helpers ──────────────────────────────────────────────────────────────────
const isEmpty = val =>
  val === null ||
  val === undefined ||
  String(val).trim() === "" ||
  String(val).trim().toLowerCase() === "null" ||
  String(val).trim().toLowerCase() === "undefined"

const clean = val => (isEmpty(val) ? "" : val)
const inputCls = val => `form-control ${isEmpty(val) ? "border-danger" : ""}`

// ─── Component ────────────────────────────────────────────────────────────────
const WorkExperience = ({ id, staffData, verticalActiveTab }) => {
  const [inputFields_1, setInputFields1] = useState([{}])

  useEffect(() => {
    if (verticalActiveTab == "3") {
      let WorkExperienceDetails
      if (staffData?.work_experience != undefined) {
        WorkExperienceDetails = JSON.parse(staffData?.work_experience)
      }
      if (WorkExperienceDetails !== null) {
        setInputFields1(WorkExperienceDetails)
      }
    }
  }, [verticalActiveTab])

  const fields = [
    { name: "company_name",    label: "Company Name",     type: "text",   col: "col-md-4" },
    { name: "from_date",       label: "From Date",        type: "date",   col: "col-md-2", style: { width: "18%" } },
    { name: "to_date",         label: "To Date",          type: "date",   col: "col-md-2", style: { width: "18%" } },
    { name: "salary",          label: "Salary",           type: "text",   col: "col-md-2", style: { width: "18%" } },
    { name: "position",        label: "Position",         type: "text",   col: "col-md-4" },
    { name: "reason_for_leave",label: "Reason For Leave", type: "text",   col: "col-md-4" },
    { name: "job_description", label: "Job Description",  type: "text",   col: "col-md-4" },
    { name: "contact_person",  label: "Contact Person",   type: "text",   col: "col-md-4" },
    { name: "we_email",        label: "Email Id",         type: "text",   col: "col-md-4" },
    { name: "we_phone_number", label: "Phone Number",     type: "number", col: "col-md-4" },
  ]

  return (
    <>
      <div>
        <div className="repeater">
          <div className="p-4 pb-0 bg-white shadow">
            <Row>
              <div className="col-md-6">
                <h4 className="text-dark">Work Experience</h4>
              </div>
            </Row>
          </div>

          {(inputFields_1 || []).map((formRow, key) => (
            <div key={key} className="mb-3 p-4 py-5 bg-white shadow">
              <Row className="align-items-center">
                {fields.map(({ name, label, type, col, style }) => (
                  <div className={`${col} mb-3`} key={name} style={style}>
                    <label>{label}</label>
                    <input
                      type={type}
                      placeholder={`Enter ${label}`}
                      className={inputCls(formRow[name])}
                      name={name}
                      value={clean(formRow[name])}
                      disabled={true}
                    />
                  </div>
                ))}
              </Row>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default WorkExperience